import {createBaseShape} from './createBaseShape'

export const createTwoHeadsArrow = (attrs) => {
  let strokeSize = 2
  let strokeColor = 'black'
  let fillColor = 'black'
  let dash
  let lineCap

  if (typeof window.strokeSize !== 'undefined') {
    strokeSize = window.strokeSize
  }

  if (typeof window.strokeColor !== 'undefined') {
    strokeColor = window.strokeColor
  }

  if (typeof window.lineType !== 'undefined') {
    dash = window.lineType[0]
    lineCap = window.lineType[1]
  }

  if (typeof window.fillColor !== 'undefined') {
    fillColor = window.fillColor
  }

  return Object.assign(
    createBaseShape({
      enabledAnchors: [
        'middle-left',
        'middle-right',
        'top-center',
        'bottom-center'
      ],
      shapeType: attrs.shapeType
    }),
    {
      points: [attrs.x, attrs.y, attrs.x + attrs.width, attrs.y],
      pointerLength: 10,
      pointerWidth: 10,
      name: 'connector',
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeSize,
      pointerAtBeginning: true
    }
  )
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createTwoHeadsArrow.js